import moment from "moment";
import React from "react";
import { useSelector } from "react-redux";

export default function Footer() {
  const scheduleTech = useSelector(
    (state) => state.rootReducer.scheduleSlice.tech
  );
  return (
    <div className="schedule__footer tech__footer">
      <div className="tech__footer-left">
        <div className="tech__footer-text">
          <img src="/assets/icons/location.svg" alt="location" />
          {scheduleTech?.job_address?.address}
        </div>
        <div className="tech__footer-text">
          <img src="/assets/icons/calendar.svg" alt="location" />
          {moment(JSON.parse(scheduleTech?.date)).format("MMMM D, YYYY")},{" "}
          {scheduleTech?.time?.label}
        </div>
        <div className="tech__footer-text">
          <img src="/assets/icons/tag.svg" alt="location" />
          {scheduleTech?.verification_key}
        </div>
      </div>
      <div className="tech__footer-right">
        <div className="tech__footer-technician">
          <div className="left">
            <img
              src={
                scheduleTech?.technician_id?.profile_image_url
                  ? scheduleTech?.technician_id?.profile_image_url
                  : `assets/icons/user-example.svg`
              }
              alt="user"
            />
          </div>
          <div className="right">
            <div>
              {scheduleTech?.technician_id?.firstname}{" "}
              {scheduleTech?.technician_id?.lastname}
            </div>
            <span>Tech ID: {scheduleTech?.technician_id?.id}</span>
          </div>
        </div>
      </div>
    </div>
  );
}
